import React from 'react';
import FinancialInfo from './FinancialInfo';
import GeneralInfo from './GeneralInfo';
import LogoWebsite from './LogoWebsite';
import classes from './GeneralFinancialInfo.module.css';

const GeneralFinancialInfo = () => {
  return (
    <div className={classes.container + ' sub-section-container'}>
      <LogoWebsite />
      <GeneralInfo />
      <FinancialInfo />
    </div>
  );
};

export default GeneralFinancialInfo;
